// The login response is persisted by authSlice; do not invent account IDs.
export function readStoredSession() {
  let user = null;
  try {
    const parsed = JSON.parse(localStorage.getItem('user') || 'null');
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) user = parsed;
  } catch { /* Corrupt storage must not prevent the login screen from loading. */ }
  return { token: localStorage.getItem('token') || null, role_id: localStorage.getItem('role_id') || user?.role_id || null, user };
}

export function clearStoredSession() {
  for (const storage of [localStorage, sessionStorage]) {
    for (const key of ['token', 'role_id', 'user', 'printContent']) storage.removeItem(key);
  }
}

export function sessionPayload(auth = readStoredSession()) {
  return { token: auth.token || '', users_id: auth.user?.users_id || auth.user?.id || '', role_id: auth.role_id || auth.user?.role_id || '' };
}
